import type { Transaction } from '@tanstack/db'
import { newRecordId, stores } from '@/lib/pocketbase'
import type { Addresses as Address } from '@/types/pbSchema'

export {
    formatAddress,
    hasExpandedAddress,
    isAddressBlank,
    isNonBlankAddress,
    isPartialAddress,
    isValidAddress,
} from './address-utils'

import { isNonBlankAddress } from './address-utils'

export function findOrCreateAddress(
    address: Partial<Address> | undefined,
    orgId: string
):
    | {
          transaction: Transaction<Record<string, unknown>>
          addressId: string
      }
    | { transaction: null; addressId: string } {
    const { addresses: store } = stores

    if (!isNonBlankAddress(address)) {
        return { transaction: null, addressId: '' }
    }

    if (address.id) {
        const transaction = store.update(address.id, draft => {
            Object.assign(draft, address)
        })
        return { transaction, addressId: address.id }
    }

    const addressId = newRecordId()
    const transaction = store.insert({
        ...address,
        id: addressId,
        org: orgId,
    })
    return { transaction, addressId }
}
